import store from '@/store/index';

export default {
    beforeEach: [
        ({ meta = {} }, from, next) => {
            if (!window.sfe.prerender) {
                if (meta.pre_symbol) store.dispatch('settings/GET_SYMBOLS');
                if (meta.pre_swap_symbol) store.dispatch('lt/GET_SWAP_SYMBOLS');
            }

            next();
        },
    ],
};
